import { render, staticRenderFns } from "./MenuStaticTags.vue?vue&type=template&id=fb8bfcf8&scoped=true"
import script from "./MenuStaticTags.vue?vue&type=script&lang=ts"
export * from "./MenuStaticTags.vue?vue&type=script&lang=ts"
import style0 from "./MenuStaticTags.vue?vue&type=style&index=0&id=fb8bfcf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8bfcf8",
  null
  
)

export default component.exports